// FTEDN Creator App — React entry point
// ⚠️ Sentry MUST init before any other imports to catch early errors
import { initSentry } from './services/sentry';
initSentry();

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '../../../shared/tokens.css';
import './styles/brand.css';
import './styles/animations.css';
import './styles/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
